import React, { useEffect, useState } from 'react';
import { ModalInfoDocument } from '../../Modals';
import MedicineStep1 from './MedicineStep1';
import MedicineStep2 from './MedicineStep2';
import MaintienEnfantStep1 from './MaintienEnfantStep1';
import SubmitForm from './SubmitForm';
import { fetchBenef } from '../../Lists/ListBenef';
import { BANETTE } from '../../Config/Config';
import PropTypes from 'prop-types';

function OrganismFormDocument(props) {
  const [show, setShow] = useState(false);
  const [benefItems, setBenefItems] = useState([]);
  const [textInfoBenef, setTextInfoBenef] = useState("");

  useEffect(() => {
    fetchBenef(props.type.name).then((benefItems) => {
      if (benefItems.length === 0 && props.type.name.toLowerCase() === BANETTE.JUSTIFICATIF_MAINTIEN_ENFANT) {
        setTextInfoBenef("Vous n'avez pas d'enfant lié à votre contrat.");
      } else {
        setBenefItems(benefItems);
        setTextInfoBenef("");
        }
    });
  }, [props.type.name]);

  if (
    props.type.name.toLowerCase() === 'facture' &&
    props.category.toLowerCase() === 'médecine douce'
  ) {
    return (
      <div>
        {props.stepMedicine === 1 && (
          <MedicineStep1
            {...props}
            benefItems={benefItems}
            setShow={setShow}
            files={props.files}
            selectedSeuil={props.seuil}
          />
        )}
        {props.stepMedicine === 2 && <MedicineStep2 {...props} />}
        <ModalInfoDocument show={show} onHide={() => setShow(false)} />
      </div>
    );
  }
  if (
    props.type.name.toLowerCase() === BANETTE.JUSTIFICATIF_MAINTIEN_ENFANT
  ) {
    return (
      <div>
        <MaintienEnfantStep1 {...props} benefItems={benefItems} setShow={setShow} textInfoBenef={textInfoBenef} />
      </div>
    );
  }

  return <SubmitForm {...props} />;
}

OrganismFormDocument.defaultProps = {
  type: '',
  category: '',
  onSubmit: null,
  onChange: null,
  onChangeSelect: null,
  description: null,
  selectFile: null,
  selectBenef: null,
  textInfoBenef: '',
  sendDocumentErrors: null,
  medicineStep: null,
  openNewMutual: null,
};

OrganismFormDocument.propTypes = {
  type: PropTypes.shape({
    name: PropTypes.string
  }),
  category: PropTypes.string,
  onSubmit: PropTypes.func,
  onChange: PropTypes.func,
  onChangeSelect: PropTypes.func,
  description: PropTypes.string,
  selectFile: PropTypes.func,
  selectBenef: PropTypes.func,
  textInfoBenef: PropTypes.string,
  medicineStep: PropTypes.func,
  openNewMutual: PropTypes.func,
  stepMedicine: PropTypes.number,
  showNewMutual: PropTypes.bool,
  mutual: PropTypes.object,
  onChangeMutual: PropTypes.func,
  files: PropTypes.array,
  remboursement: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isUploadValid: PropTypes.bool,
  isDescriptionValid: PropTypes.bool,
  sendDocumentErrors: PropTypes.arrayOf(PropTypes.string),
  seuil: PropTypes.number,
  medicine: PropTypes.object,
  onChangeMedicine: PropTypes.func
};

export default OrganismFormDocument;
